var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{attrs:{"label":"Zones","label-for":"zones"}},[_c('v-select',{attrs:{"id":"zones","label":"name","options":_vm.zones,"loading":_vm.loadingZones},on:{"input":_vm.onZoneSelected}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }